module.exports = __webpack_public_path__ + "static/media/detail_0052_t.6b998021.jpg";